"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { WaveDropIdentity } from "@/components/waves/drops/identity/WaveDropIdentity";
import { getDropVisibleMetadata } from "@/components/waves/drops/identityDisplay.helpers";
import { SingleWaveDropContentMetadata } from "./SingleWaveDropContentMetadata";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropContent from "../drops/WaveDropContent";
import { ImageScale } from "@/helpers/image.helpers";
interface SingleWaveDropContentProps {
  readonly drop: ExtendedDrop;
}
export const SingleWaveDropContent: React.FC<SingleWaveDropContentProps> = t0 => {
  const $ = _c(14);
  const {
    drop
  } = t0;
  const [activePartIndex, setActivePartIndex] = useState(0);
  let t1;
  if ($[0] !== drop.metadata || $[1] !== drop.wave) {
    t1 = getDropVisibleMetadata({
      wave: drop.wave,
      metadata: drop.metadata
    });
    $[0] = drop.metadata;
    $[1] = drop.wave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const visibleMetadata = t1;
  let t2;
  if ($[3] !== activePartIndex || $[4] !== drop) {
    t2 = <WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={_temp} onQuoteClick={_temp2} setLongPressTriggered={_temp3} mediaImageScale={ImageScale.AUTOx1080} />;
    $[3] = activePartIndex;
    $[4] = drop;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== drop) {
    t3 = <WaveDropIdentity drop={drop} variant="full" />;
    $[6] = drop;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== visibleMetadata) {
    t4 = visibleMetadata.length > 0 && <SingleWaveDropContentMetadata metadata={visibleMetadata} />;
    $[8] = visibleMetadata;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className="tw-mb-4 tw-flex tw-flex-col tw-gap-y-4">{t2}{t3}{t4}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp() {}
function _temp2() {}
function _temp3() {}